import React from 'react';
import { Link } from 'react-router-dom';

import './stylings/SiteHeader.css';

export default class SiteHeader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			mobileNavIsOpen: false
		};
	}
	
	toggleNavMenu = () => {
		console.log('set state to ', !this.state.mobileNavIsOpen);
		this.setState({mobileNavIsOpen: !this.state.mobileNavIsOpen});
	}

	renderMobileNavigation() {
		if (this.state.mobileNavIsOpen) {
			return (
				<nav className="site-header__nav__mobile">
					<ul id="nav-ul" className="site-header__nav-menu clearfix animated slideInRight">
						<li className="site-header__nav-menu-item" onClick={this.toggleNavMenu}>
							<Link to="/neues">Neues</Link>
						</li>
						<li className="site-header__nav-menu-item"onClick={this.toggleNavMenu}>
							<Link to="/entdecken">Entdecken</Link>
						</li>
						<li className="site-header__nav-menu-item" onClick={this.toggleNavMenu}>
							<Link to="/stadtgefluester">Stadtgeflüster</Link>
						</li>
						<li className="site-header__nav-menu-item" onClick={this.toggleNavMenu}>
							<Link to="/ueber-uns">Über Uns</Link>
						</li>
					</ul>
				</nav>
			);
		} else {
			return;
		}
	}

	render () {
		const renderedMobileNav = this.renderMobileNavigation();

		return (
			<header className="site-header">
				<div className="site-header__header-main">
					<div className="container">
						<div className="site-header__header-inner clearfix">
							<div className="medium-header-container">
								<a href="/" className="site-header__header-logo">
									<img src="/logo.png" alt="logo"/>
								</a>

								
							<nav className="site-header__nav">
								<ul id="nav-ul" className="site-header__nav-menu clearfix">
									<li className="site-header__nav-menu-item">
										<Link to="/neues">Neues</Link>
									</li>
									<li className="site-header__nav-menu-item">
										<Link to="/entdecken">Entdecken</Link>
									</li>
									<li className="site-header__nav-menu-item">
										<Link to="/stadtgefluester">Stadtgeflüster</Link>
									</li>
									<li className="site-header__nav-menu-item">
										<Link to="/ueber-uns">Über Uns</Link>
									</li>
								</ul>
							</nav>


							<div className="site-header__mobile-nav-toggle" onClick={this.toggleNavMenu}>
								<i className="fa fa-bars"/>
							</div>

							{renderedMobileNav}

							</div>
							
						</div>	
					</div>
				</div>
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/SiteHeader.js